import { AsperaTransferDownloadSetupTransferRequestPath } from "./aspera-transfer-download-setup-transfer-request-path";
import { AsperaTransferDirection } from "./aspera-transfer-direction";
import { TransferSpec } from "@ibm-aspera/connect-sdk-js/dist/esm/core/types";

export class AsperaTransferSpecBasic {
  http_fallback: boolean | null = null;
  ssh_port: number | null = 0;
  fasp_port: number | null = 0;
  http_fallback_port: number | null = 0;
  target_rate_kbps: number | null = 0;
  min_rate_kbps: number | null = 0;
  source_root: string | null = null;
  destination_root: string | null = null;
  authentication: string | null = null;
  token: string | null = null;
  direction: string | null = null;
  cipher: string | null = null;
  rate_policy_allowed: string | null = null;
  rate_policy: string | null = null;
  remote_host: string | null = null;
  remote_user: string | null = null;
  creationDate: Date | null = null;
  paths: AsperaTransferDownloadSetupTransferRequestPath[] | null = null;
  directionEnum: AsperaTransferDirection | null = null;

  constructor(init?: Partial<AsperaTransferSpecBasic>) {
    Object.assign(this, init);
  }
}

export const TransferSpecDTO = (data: AsperaTransferSpecBasic): TransferSpec => {
  let spec: TransferSpec = {
    paths:
      data.paths !== null
        ? data.paths.map((x) => {
            return { destination: x.destination!, source: x.source! };
          })
        : [],
    remote_host: data.remote_host !== null ? data.remote_host : "",
    direction: data.direction !== null ? data.direction : "",
    token: data.token !== null ? data.token : undefined,
    http_fallback: data.http_fallback !== null ? data.http_fallback : undefined,
    http_fallback_port: data.http_fallback_port !== null ? data.http_fallback_port : undefined,
    ssh_port: data.ssh_port !== null ? data.ssh_port : undefined,
    fasp_port: data.fasp_port !== null ? data.fasp_port : undefined,
    target_rate_kbps: data.target_rate_kbps !== null ? data.target_rate_kbps : undefined,
    min_rate_kbps: data.min_rate_kbps !== null ? data.min_rate_kbps : undefined,
    source_root: data.source_root !== null ? data.source_root : undefined,
    destination_root: data.destination_root !== null ? data.destination_root : undefined,
    authentication: data.authentication !== null ? data.authentication : undefined,
    cipher: data.cipher !== null ? data.cipher : undefined,
    rate_policy: data.rate_policy !== null ? data.rate_policy : undefined,
    remote_user: data.remote_user !== null ? data.remote_user : undefined,
  };
  return spec;
};
